import { Component, Vue } from 'vue-property-decorator'
import HighFilter from '@/components/highFilter/index.vue'
import { UserModule } from '@/store/modules/user'
import { queryHomeLayerData, queryHomeTimeTable, queryHomePersonEfficacy, queryHomebacklog, createHomebacklog, editHomebacklog, deleteHomebacklog, finishHomebacklog } from '@/api'
@Component({ name: 'HomePage', components: { HighFilter } })
export default class HomePage extends Vue {
  [x: string]: any
  private homeLayerData: any = {} // 头部数据
  private classTableData: any = {} // 上课情况
  private WorkKanban: any = {} // 工作看板
  private personEfficacy: any = []
  private customTimeType: any = null
  private activeDataType: any = true
  private activePersonType: any = 0
  private customTimeDialogShow: any = false
  private stratTime: any = ''
  private endTime: any = ''
  private placementShow: any = true
  private useRole: any = []
  private agencyList: any = [1, 2, 3, 4, 4, 5]
  private tableloading: any = false
  private tableloading1: any = false
  private hoverid: any = null

  private Axisobj: any = { // x轴文字的配置
    show: true,
    textStyle: {
      color: '#141D45',
      fontSize: 12
    }
  }

  private Axisobj1: any = {
    axisLine: {
      symbol: ['none', 'arrow']
    },
    lineStyle: {
      type: 'arrow',
      color: '#ababab'
    }
  }

  private normal = {
    show: true, // 开启显示
    position: 'top', // 在上方显示
    textStyle: { // 数值样式
      color: '#141D45',
      fontSize: 11
    }
  }

  private tableData: any = []
  private tableData1: any = []
  private tableDataAll: any = null

  created () {
    if (this.$store.state.user.roles.find((item: any) => item.indexOf('普通助教') < 0)) {
      this.queryHomeLayerData() // 头部数据
    }
    if (this.$store.state.user.roles.find((item: any) => item.indexOf('运营总监') > -1)) {
      this.queryHomePersonEfficacy() // 人员效能 运营主管
    }
    if (this.$store.state.user.roles.find((item: any) => item.indexOf('运营专员') > -1 || item.indexOf('运营主管') > -1 || item.indexOf('销售') > -1)) {
      this.queryHomeTimeTable() // 上课情况 销售 和 专员
      this.queryHomebacklog() // 工作看板 销售 和 专员
    }
  }

  mounted () {
    this.useRole = this.$store.state.user.roles
  }

  private async queryHomeLayerData () {
    this.tableloading = true
    const param: any = {}
    if (this.activeDataType && this.activeDataType !== 3 && this.activeDataType !== -1) {
      param.isAll = this.activeDataType
    } else {
      if (this.activeDataType === 3) {
        param.startTime = this.stratTime
        param.endTime = this.endTime
      } else {
        param.month = String(this.activeDataType)
      }
    }
    const result = await queryHomeLayerData(param)
    this.homeLayerData = result
    this.tableData = []
    if (this.$store.state.user.roles.find((item: any) => item.indexOf('运营总监') > -1)) {
      const obj = {
        row: this.homeLayerData.tableAll.inClassClassNum ? this.homeLayerData.tableAll.inClassClassNum : '--',
        row1: this.homeLayerData.tableAll.willStartClassNum ? this.homeLayerData.tableAll.willStartClassNum : '--',
        row2: this.homeLayerData.tableAll.endClassNum ? this.homeLayerData.tableAll.endClassNum : '--',
        row3: this.homeLayerData.tableAll.endStudentNum ? this.homeLayerData.tableAll.endStudentNum : '--',
        row4: this.homeLayerData.tableAll.anomalyClassNum ? this.homeLayerData.tableAll.anomalyClassNum : '--',
        row5: this.homeLayerData.tableAll.anomalyStudentNum ? this.homeLayerData.tableAll.anomalyStudentNum : '--'
      }
      this.tableData = [obj]
    } else {
      const list = ['小组科研', '1V1', '独立论文学生']
      list.forEach((item: any, index: any) => {
        let obj = { name: item }
        if (index === 0) {
          obj = Object.assign(this.homeLayerData.tableClass.pbl, obj)
        }
        if (index === 1) {
          obj = Object.assign(this.homeLayerData.tableClass.oneToOne, obj)
        }
        if (index === 2) {
          obj = Object.assign(this.homeLayerData.tableClass.paper, obj)
        }
        this.tableData.push(obj)
      })
    }
    this.initCircle()
    this.tableloading = false
  }

  private async queryHomeTimeTable () {
    const result = await queryHomeTimeTable({})
    this.classTableData = result
  }

  private async queryHomePersonEfficacy () {
    this.tableloading1 = true
    const param: any = {}
    if (this.activePersonType === 3) {
      param.startTime = this.stratTime
      param.endTime = this.endTime
    } else {
      param.month = String(this.activePersonType)
    }
    const result: any = await queryHomePersonEfficacy(param)
    this.personEfficacy = result.personBar
    this.tableDataAll = result.personTable
    const data = result.personTable
    const studentNum: any = {
      title: '学生总数'
    }
    const willStartClassNum: any = {
      title: '新开班级总数量'
    }
    const willStartStudentNum: any = {
      title: '新开1V1学生数量'
    }
    const endClassNum: any = {
      title: '结课班级数量'
    }

    studentNum.list = data.map((item: any) => { return item.studentNum })
    willStartClassNum.list = data.map((item: any) => { return item.newStartClassNum })
    willStartStudentNum.list = data.map((item: any) => { return item.newStartStudentNum_oneToOne })
    endClassNum.list = data.map((item: any) => { return item.endClassNum })
    this.tableData1 = [studentNum, willStartClassNum, willStartStudentNum, endClassNum]
    this.columnar()
    this.tableloading1 = false
  }

  private async queryHomebacklog () {
    const result: any = await queryHomebacklog({})
    this.WorkKanban = result
    this.agencyList = this.WorkKanban.notDone
  }

  private getMonthData (type: any) {
    if (!this.tableloading) {
      // 1.type 上月 2.本月 3，自定义
      this.activeDataType = type
      this.queryHomeLayerData()
    }
  }

  private getMonthDataPerson (type: any) {
    if (!this.tableloading1) {
      // 1.type 上月 2.本月 3，自定义
      this.activePersonType = type
      this.queryHomePersonEfficacy()
    }
  }

  private getCustomTimeData () {
    if (this.customTimeType === 1) { // 查数据环形图
      this.activeDataType = 3
      this.queryHomeLayerData()
    } else {
      this.activePersonType = 3
      this.queryHomePersonEfficacy()
    }
    this.stratTime = ''
    this.endTime = ''
  }

  private goLookDetail () {
    this.$router.push({ path: '/student/list' })
  }

  private async doneItem (item: any) {
    if (!item.id || !item.detail) {
      this.$message({ type: 'error', message: '内容不能为空' })
      return
    }
    await finishHomebacklog({ id: item.id })
    this.queryHomebacklog()
  }

  private async addAgency (type: any, item: any) {
    if (type === 1) {
      if (item.id) {
        await deleteHomebacklog({ id: item.id })
        this.$message({ type: 'success', message: '删除成功' })
        this.queryHomebacklog()
      } else {
        this.agencyList.splice(this.agencyList.indexOf(item), 1)
      }
    } else {
      const obj = {
        detail: '',
        disabled: true
      }
      this.agencyList.push(obj)
    }
  }

  private async editAgency (item: any) {
    if (item.id) {
      await editHomebacklog({ detail: item.detail, id: item.id })
      this.$set(item, 'disabled', false)
    } else {
      await createHomebacklog({ detail: item.detail })
      this.queryHomebacklog()
      this.$set(item, 'disabled', false)
    }
  }

  private async clickedit (item: any) {
    await this.$set(item, 'disabled', true)
  }

  private async selectStyle (item: any) {
    this.hoverid = item.id
  }

  private async outStyle (item: any) {
    this.hoverid = ''
  }

  // 饼状图
  private initCircle () {
    const option = {
      title: {
        text: '',
        subtext: '',
        left: 'center',
        top: '34%',
        textStyle: {
          color: '#141D45',
          fontSize: 14,
          fontWeight: '700'
        },
        subtextStyle: {
          color: '#141D45',
          fontSize: 12
        }
      },
      series: [
        {
          type: 'pie',
          radius: ['56%', '66%'],
          center: ['50%', '50%'],
          label: {
            show: false
          },
          emphasis: {
            label: {
              show: false
            }
          },
          labelLine: {
            show: false
          },
          data: [
            { value: '', itemStyle: { color: '#E8F0FF' } }, // 总数
            { value: 1, itemStyle: { color: 'red' } } // 分数
          ]
        }
      ]
    }

    const chart1 = this.$refs.chart1
    const chart2 = this.$refs.chart2
    const chart3 = this.$refs.chart3
    const chart4 = this.$refs.chart4
    const chart5 = this.$refs.chart5

    if (chart1) {
      const list = [chart1, chart2, chart3, chart4, chart5]
      const list1 = ['#FFC1B5', '#A5BDFF', '#B8E986', '#D3A1FF', '#FFD38C']
      const list3 = ['累计学生总数', '累计班级总数', '小组科研人数', '1v1总人数', '论文总人数']
      const list4 = [this.homeLayerData.cake.allStudentNum,
        this.homeLayerData.cake.allClassNum,
        this.homeLayerData.cake.pblStudentNum,
        this.homeLayerData.cake.oneToOneStudentNum,
        this.homeLayerData.cake.paperStudentNum]
      list.forEach((item, index) => {
        const myChart1 = this.$echarts.init(item)
        const option1 = JSON.parse(JSON.stringify(option))
        option1.series[0].data[1].itemStyle = { color: list1[index] }
        option1.title.text = list3[index]
        option1.title.subtext = list4[index] || '0'
        if (index > 1) {
          option1.series[0].data[0].value = list4[0] - list4[index] // 圆形图剩余比例
          option1.series[0].data[1].value = list4[0] ? list4[index] : '' // 圆形图学生占比例
        } else {
          option1.series[0].data[0].value = 0
        }
        myChart1.setOption(option1)
      })
    }
  }

  // 柱状图
  private columnar () {
    const option1 = {
      legend: {
        right: 0,
        data: ['班级数量', '1V1人数', '异常中数量']
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '8%',
        containLabel: true
      },
      dataZoom: [
        {
          type: 'slider',
          show: true,
          height: 12,
          bottom: 0,
          backgroundColor: '#fff',
          handleIcon: 'M512 512m-208 0a6.5 6.5 0 1 0 416 0 6.5 6.5 0 1 0-416 0Z M512 192C335.264 192 192 335.264 192 512c0 176.736 143.264 320 320 320s320-143.264 320-320C832 335.264 688.736 192 512 192zM512 800c-159.072 0-288-128.928-288-288 0-159.072 128.928-288 288-288s288 128.928 288 288C800 671.072 671.072 800 512 800z',
          handleColor: '#fff',
          handleSize: 14,
          handleStyle: {
            borderColor: '#fff',
            shadowBlur: 1,
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowColor: '#ddd'
          },
          start: 0,
          end: 50,
          zoomLock: true
        }
      ],
      xAxis: [
        {
          type: 'category',
          axisLabel: {},
          splitLine: {
            show: false
          },
          axisLine: {
          },
          data: []
        }
      ],
      yAxis: [
        {
          type: 'value',
          name: '进行中',
          axisLabel: { // x轴文字的配置
          },
          splitLine: {
            show: false
          },
          axisLine: {
          }
        }
      ],
      series: [
        {
          name: '班级数量',
          type: 'bar',
          barMinHeight: 2,
          barWidth: 22,
          itemStyle: {
            normal: {
              color: '#B8E986',
              label: {}
            }
          },
          data: []
        },
        {
          name: '1V1人数',
          type: 'bar',
          barWidth: 22,
          barMinHeight: 2,
          itemStyle: {
            normal: {
              color: '#A5BDFF'
            }
          },
          data: []
        },
        {
          name: '异常中数量',
          type: 'bar',
          barWidth: 22,
          barMinHeight: 2,
          itemStyle: {
            normal: {
              color: '#FFC1B5'
            }
          },
          data: []
        }
      ]
    }
    const chart6 = this.$refs.chart6
    if (chart6) {
      const myChart6 = this.$echarts.init(chart6)
      option1.xAxis[0].axisLabel = this.Axisobj
      option1.yAxis[0].axisLabel = this.Axisobj
      option1.xAxis[0].axisLine = this.Axisobj1
      option1.yAxis[0].axisLine = this.Axisobj1
      option1.dataZoom[0].end = Math.round(8 / this.personEfficacy.length * 100)
      option1.xAxis[0].data = this.personEfficacy.map((item: any) => { return item.userName }) // 学员名称
      option1.series[0].data = this.personEfficacy.map((item: any) => { return item.startingClassNum }) // 班级
      option1.series[1].data = this.personEfficacy.map((item: any) => { return item.oneToOneStudentNum }) // 1v1
      option1.series[2].data = this.personEfficacy.map((item: any) => { return item.anomalyNum }) // 异常
      option1.series.forEach((item: any) => {
        item.itemStyle.normal.label = this.normal
      })
      myChart6.setOption(option1)
    }
  }
}
